import React from "react";
import { motion } from "framer-motion";

const insightsData = [
    {
        id: 1,
        title: "Adaptive Trust Framework for Enterprise AI Governance",
        desc: "A modern governance framework designed for autonomous AI agents that adapts continuously to their behavior, intent, permissions, and evolving risk across enterprise environments.",
        isDark: true,
    },
    {
        id: 2,
        title: "Integrated AI Identity and Access Management",
        desc: "Brings together Microsoft Entra Agent ID and Tech Mahindra’s AI governance capabilities to deliver secure, auditable, and role-based identity management for AI agents.",
        isDark: false,
    },
    {
        id: 3,
        title: "OWASP-Aligned Security and Risk Mitigation",
        desc: "Maps enterprise AI risks to OWASP GenAI security standards, enabling organizations address threats such as tool misuse, privilege abuse, and memory poisoning with greater clarity and control.",
        isDark: false,
    },
    {
        id: 4,
        title: "Behavioural Validation and Continuous Monitoring",
        desc: "Uses AI validation and continuous behavioural monitoring to detect anomalies, track agent activity, and support responsible execution across workflows and connected systems.",
        isDark: false,
    },
    {
        id: 5,
        title: "Scalable Governance for Autonomous AI Systems",
        desc: "Applies least-privilege access, conditional policies, and adaptive authorization to securely scale agentic AI deployments.",
        isDark: false,
    },
];

const KeyInsights = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.12 },
        },
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
    };

    return (
        <section className="w-full bg-white pb-12 sm:pb-16 md:pb-20 lg:pb-24 text-left relative z-10 font-sans overflow-hidden">
            <div className="max-w-[1440px] mx-auto w-full px-5 sm:px-10 lg:px-[80px]">

                <div className="text-center mb-10 sm:mb-14 md:mb-16 w-full px-1">
                    <h2 className="text-[20px] md:text-[30px] font-[600] font-sora text-[#01386A] leading-tight tracking-tight">
                        Key Insights
                    </h2>
                </div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 w-full items-stretch"
                >
                    {insightsData.map((insight) => (
                        <motion.div
                            key={insight.id}
                            variants={cardVariants}
                            whileHover={{ y: -6, scale: 1.01, transition: { duration: 0.3 } }}
                            className="group relative p-6 sm:p-8 md:p-10 flex flex-col justify-between w-full min-h-[300px] sm:min-h-[340px] md:min-h-[380px] shrink-0 bg-[#F0F0F0] overflow-hidden border-none outline-none transition-all duration-300 ease-out hover:shadow-xl before:content-[''] before:absolute before:inset-0 before:bg-[#01386A] before:top-full hover:before:top-0 before:transition-all before:duration-500 before:ease-in-out before:z-0"
                        >
                            <div className="w-full flex flex-col gap-6 sm:gap-8 lg:gap-12 relative z-10 pointer-events-none">
                                <h3
                                    className="text-[16px] md:text-[20px] font-[600] font-sora text-[#01386A] group-hover:text-[#FFFFFF] leading-snug tracking-tight break-words transition-colors duration-300 ease-in-out"
                                >
                                    {insight.title}
                                </h3>

                                <p
                                    className="text-[14px] md:text-[16px] leading-relaxed font-[500] font-graphik text-[#01386A] group-hover:text-[#FFFFFF] break-words transition-colors duration-300 ease-in-out"
                                >
                                    {insight.desc}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    );
};

export default KeyInsights;